import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { isUseCase } from '@/lib/utils'

// site absent = the user's current site.
export const SearchSchema = z.object({
  site: z.string().optional(),
})

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/air-quality/map/')({
  validateSearch: SearchSchema,
  async beforeLoad() {
    if (!isUseCase(UseCase.AIR_QUALITY)) {
      throw redirect({
        to: '/403',
        search: { reason: 'wrongUseCase' },
      })
    }
  },
  pendingComponent: PendingComponent,
})
